define("powergen/models/game",
  [],
  function() {
    "use strict";
    var Game;

    Game = DS.Model.extend({
      name: DS.attr('string'),
      systems: DS.hasMany('system'),
      keyboards: DS.hasMany('keyboard'),
      reset: function() {
        this.get('manager').resetUser();
        this.setProperties({
          'manager.gameWasCompleted': true
        });
        return this.get('systems').forEach(function(system) {
          return system.reset();
        });
      }
    });


    return Game;
  });